export const pxToRem = (value: number): string => `${value / 16}rem`

export const remToPx = (value: number): string => `${value * 16}px`

export const withFilterStyledProps = (keyProps: string[]) => {
  const filterProps = (prop: PropertyKey) => !keyProps.includes(prop as string)
  return { shouldForwardProp: filterProps }
}
